import {path, pickBy, startsWith, reject} from 'ramda'
import {selectSearchObj, selectHash} from '@modifi/router'

import {TRACK_ACTION_FORM} from '../../constants/tracking'
import {REDUCER_KEY, ACTION_TYPES} from './constants'
import {serviceClientFactory} from '../../lib/ownClient'
import {selectByAlpha2} from '../../custom-plugins/countries'

const initialState = {
  isSubmitting: false,
  isSubmitted: false,
  hasError: false,
  errorMessage: '',
  campaignData: {},
}

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case ACTION_TYPES.SIGN_UP_PERSIST_CAMPAIGN:
      if (state.campaignData.referrer) {
        // eslint-disable-next-line no-param-reassign
        delete payload.referrer
      }
      return {
        ...state,
        campaignData: {
          ...state.campaignData,
          ...payload,
        },
      }
    case ACTION_TYPES.SIGN_UP_SUBMIT_FORM_PENDING:
      return {
        ...state,
        isSubmitting: true,
      }
    case ACTION_TYPES.SIGN_UP_SUBMIT_FORM_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        isSubmitted: true,
      }
    case ACTION_TYPES.SIGN_UP_SUBMIT_FORM_ERROR: {
      const {errorMessage} = payload
      return {
        ...state,
        isSubmitting: false,
        hasError: true,
        errorMessage,
      }
    }

    case ACTION_TYPES.SIGN_UP_SUBMIT_FORM_RESET:
      return {
        ...initialState,
        campaignData: state.campaignData,
      }

    default:
      return state
  }
}

const getReferrer = () => {
  const rawRef = document.referrer
  const {origin} = document.location
  const ownHost = `${origin}`
  if (rawRef.indexOf(ownHost) === 0) {
    return null
  }
  // [0-9A-Za-z-_&\\.\\/: ]+
  return (rawRef || '').replace(/[^\w\d-_&./: ]/g, '_')
}
const cleanCampaignId = rawId => (rawId || '').replace(/[^\w\d-_&./: ]/g, '_')

export const selectPersistedCampaign = state => state[REDUCER_KEY].campaignData
export const selectIsSubmitting = state => state[REDUCER_KEY].isSubmitting
export const selectIsSubmitted = state => state[REDUCER_KEY].isSubmitted
export const selectHasError = state => state[REDUCER_KEY].hasError
export const selectErrorMessage = state => state[REDUCER_KEY].errorMessage

const setCampaignParameters = campaignArguments => {
  const params = {
    referer: campaignArguments?.referrer,
    campaignId: cleanCampaignId(campaignArguments?.utm_campaign),
    utmSource: campaignArguments?.utm_source,
    utmMedium: campaignArguments?.utm_medium,
    utmTerm: campaignArguments?.utm_term,
    utmContent: campaignArguments?.utm_content,
  }
  return reject(paramValue => !paramValue, params)
}

export const aSubmitForm = formData => async (dispatch, getState) => {
  const {country, countryCode, phone, captchaToken, exportVolumeCategory, ...restData} = formData
  const {phonePrefix} = selectByAlpha2(getState(), countryCode)
  const campaignArguments = selectPersistedCampaign(getState())

  const body = {
    ...restData,
    country,
    phoneNumber: `${phonePrefix}-${phone}`,
    'g-recaptcha-response': captchaToken,
    ...setCampaignParameters(campaignArguments),
    exportVolumeCategory: exportVolumeCategory || null,
  }

  dispatch({
    type: ACTION_TYPES.SIGN_UP_SUBMIT_FORM_PENDING,
    payload: {formData},
  })

  const client = serviceClientFactory(getState())

  await client.SignUp.submit({body})
    .then(response => response.data())
    .catch(error => {
      dispatch({
        type: ACTION_TYPES.SIGN_UP_SUBMIT_FORM_ERROR,
        payload: {
          formData,
          errorMessage:
            path(['error', 'responseData', 'errorMessage'], error.data()) ||
            path(['message'], error.data()) ||
            path(['error'], error.data()) ||
            'Internal error occurred',
        },
      })
      throw error
    })

  dispatch({
    type: ACTION_TYPES.SIGN_UP_SUBMIT_FORM_SUCCESS,
    payload: {formData},
    meta: {
      analytics: {
        event: 'form-submit',
        action: TRACK_ACTION_FORM,
        label: 'Sign Up Form Submitted',
        campaign: campaignArguments,
      },
      tracking: {
        event: 'form-submit',
        action: TRACK_ACTION_FORM,
        label: 'Sign Up Form Submitted',
        campaign: campaignArguments,
      },
    },
  })

  if (selectHash(getState())) {
    // hack for now @todo use proper router action
    document.location.hash = ''
  }
}

export const aResetForm = () => dispatch => dispatch({type: ACTION_TYPES.SIGN_UP_SUBMIT_FORM_RESET})
export const aStoreCampaignData = () => (dispatch, getState) => {
  const campaignArguments = pickBy(
    (val, key) => startsWith('utm', key),
    selectSearchObj(getState())
  )

  if (Object.keys(campaignArguments).length > 0) {
    campaignArguments.referrer = getReferrer()
    dispatch({
      type: ACTION_TYPES.SIGN_UP_PERSIST_CAMPAIGN,
      payload: {
        ...campaignArguments,
      },
    })
  }
}

export default reducer
